import React from 'react';
import { checkSize, checkColor } from './svg.helper';

export function vehicleCoupe(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
      data-testid="ads-icon__svg"
    >
      <path
        d="M11.338 7a6 6 0 013.087.855L18 10l3.743 1.497A2 2 0 0123 13.354V16a1 1 0 01-1 1h-2.171a3.001 3.001 0 01-5.658 0H8.829a3.001 3.001 0 01-5.658 0H2a1 1 0 01-1-1v-3.465a1 1 0 01.445-.832L2.5 11h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h3.499l.244-.243A6 6 0 019.485 7h1.853zM6 15a1 1 0 100 2 1 1 0 000-2zm11 0a1 1 0 100 2 1 1 0 000-2zm-5.893-6H9.594a4 4 0 00-2.746 1.091l-1.446 1.365L3 13v2l.17.001a3.001 3.001 0 015.66 0h5.34a3.001 3.001 0 015.66 0H21v-1.649l-2.126-.852H12.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h2.286l-1.687-.968a4 4 0 00-1.73-.523L11.107 9z"
        fill={checkColor(color)}
        fillRule="evenodd"
      />
    </svg>
  );
}

export function vehicleMinivan(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
      data-testid="ads-icon__svg"
    >
      <path
        d="M18.078 6a1 1 0 01.92.608l1.572 3.69a2 2 0 00.99 1.026l.865.406a1 1 0 01.575.905V16a1 1 0 01-1 1h-2.171a3.001 3.001 0 01-5.658 0H8.829a3.001 3.001 0 01-5.658 0H2a1 1 0 01-1-1V7a1 1 0 011-1zM6 15a1 1 0 100 2 1 1 0 000-2zm11 0a1 1 0 100 2 1 1 0 000-2zm.772-7H3v6.997h.172a3.001 3.001 0 015.656 0l5.343.001a3.001 3.001 0 015.658.001H21v-2l-1.242-.537L17.772 8z"
        fill={checkColor(color)}
        fillRule="evenodd"
      />
      <path
        d="M8.5 10.46h12v2h-12a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5z"
        fill={checkColor(color)}
      />
    </svg>
  );
}

export function vehicleMotorcycle(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
      data-testid="ads-icon__svg"
    >
      <path
        d="M4.17 11H4h.17M9 6a1 1 0 001 1h1.762a2 2 0 011.414.586L14.59 9h-2.646a4 4 0 00-1.789.422L7 11 5.586 9.586A2 2 0 004.172 9H1a1 1 0 100 2h3c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4l1.707 1.707a1 1 0 00.707.293h2.006a1 1 0 00.868-.503L16.49 10.9l1.01 1.01c-.91.73-1.5 1.84-1.5 3.09 0 2.21 1.79 4 4 4s4-1.79 4-4-1.79-4-4-4c-.18 0-.36.03-.53.05L17.41 9H20V6l-3.72 1.86-2.285-2.277A2 2 0 0012.584 5H10a1 1 0 00-1 1zm11 11c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM4 17c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
        fill={checkColor(color)}
        fillRule="evenodd"
      />
      <path fill="#FFF" d="M14.59 11h-3.21L8.5 12.5l2.026 2.5h1.653z" />
    </svg>
  );
}

export function vehicleSUV(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
      data-testid="ads-icon__svg"
    >
      <path
        d="M3.5 5l.07.006c.035-.004.07-.006.107-.006h9.909a1 1 0 01.707.293L18 9l4.371 1.749a1 1 0 01.629.928V16a1 1 0 01-1 1h-2.171a3.001 3.001 0 01-5.658 0H8.829a3.001 3.001 0 01-5.658 0H2a1 1 0 01-1-1v-5.615a2 2 0 01.143-.743L2.199 7H1.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h2zM6 15a1 1 0 100 2 1 1 0 000-2zm11 0a1 1 0 100 2 1 1 0 000-2zm-3.827-8h-8.82L3 10.383v4.622l.17-.001a3.001 3.001 0 015.594-.173l.067.173h5.338a3.001 3.001 0 015.595-.173l.067.173 1.17.001v-2.649l-.89-.356H8.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h7.668l-2.995-3z"
        fill={checkColor(color)}
        fillRule="evenodd"
      />
    </svg>
  );
}

export function vehicleSedan(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
      data-testid="ads-icon__svg"
    >
      <path
        d="M13.586 6a1 1 0 01.707.293L18 10l3.743 1.497A2 2 0 0123 13.354V16a1 1 0 01-1 1h-2.171a3.001 3.001 0 01-5.658 0H8.829a3.001 3.001 0 01-5.658 0H2a1 1 0 01-1-1v-3.465a1 1 0 01.445-.832L4 10l2.7-3.6a1 1 0 01.8-.4h6.086zM6 15a1 1 0 100 2 1 1 0 000-2zm11 0a1 1 0 100 2 1 1 0 000-2zm-3.826-7h-5.17l-2.602 3.456L3 13v2l.17.001a3.001 3.001 0 015.66 0h5.34a3.001 3.001 0 015.66 0H21v-1.649l-3.4-1.362a.502.502 0 01-.1.01h-8a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h5.674l-2-2z"
        fill={checkColor(color)}
        fillRule="evenodd"
      />
    </svg>
  );
}

export function vehiclePickupTruck(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
      data-testid="ads-icon__svg"
    >
      <path
        d="M14.5 5a1 1 0 01.8.4L18 9l3.392.678A2 2 0 0123 11.64V16a1 1 0 01-1 1h-1.171a3.001 3.001 0 01-5.658 0H9.829a3.001 3.001 0 01-5.658 0H2a1 1 0 01-1-1v-5.5a1 1 0 011-1h5V6a1 1 0 011-1h6.5zm-.501 2H9v4.5H3V15h1.17a3.001 3.001 0 015.66 0h5.34a3.001 3.001 0 015.66 0H21v-3.363l-4.15-.828L13.998 7zM7 17a1 1 0 100-2 1 1 0 000 2zm11 0a1 1 0 100-2 1 1 0 000 2z"
        fill={checkColor(color)}
        fillRule="evenodd"
      />
      <path
        d="M12.5 9.5h7.191a.5.5 0 01.447.276l.5 1a.5.5 0 01-.447.724H12.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5z"
        fill={checkColor(color)}
      />
    </svg>
  );
}

export function vehicleHatchback(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
      data-testid="ads-icon__svg"
    >
      <path
        d="M13.5857864,6 C13.8510029,6 14.1053568,6.10535684 14.2928932,6.29289322 L18,10 L21.7427814,11.4971125 C22.5020981,11.8008392 23,12.5362567 23,13.3540659 L23,16 C23,16.5522847 22.5522847,17 22,17 L19.8289758,17.0009007 C19.4168852,18.1656226 18.3058822,19 17,19 C15.6941178,19 14.5831148,18.1656226 14.1710242,17.0009007 L8.82897577,17.0009007 C8.41688515,18.1656226 7.30588222,19 6,19 C4.69411778,19 3.58311485,18.1656226 3.17102423,17.0009007 L2,17 C1.44771525,17 1,16.5522847 1,16 L1,12.236068 C1,12.0808229 1.03614509,11.9277098 1.10557281,11.7888544 L2,10 L3.7236068,6.5527864 C3.89299881,6.21400238 4.23926193,6 4.61803399,6 L13.5857864,6 Z M6,15 C5.44771525,15 5,15.4477152 5,16 C5,16.5522847 5.44771525,17 6,17 C6.55228475,17 7,16.5522847 7,16 C7,15.4477152 6.55228475,15 6,15 Z M17,15 C16.4477153,15 16,15.4477152 16,16 C16,16.5522847 16.4477153,17 17,17 C17.5522847,17 18,16.5522847 18,16 C18,15.4477152 17.5522847,15 17,15 Z M13.173966,8.00045576 L5.00435678,8.00045576 L3.4021647,11.4562011 L3,13 L3,15.0008619 L3.17032466,15.0010787 C3.58185634,13.8353229 4.69337811,13 6,13 C7.30662189,13 8.41814366,13.8353229 8.82967534,15.0010787 L8.82967534,15.0010787 L14.1703247,15.0010787 C14.5818563,13.8353229 15.6933781,13 17,13 C18.3066219,13 19.4181437,13.8353229 19.8296753,15.0010787 L19.8296753,15.0010787 L21,15.0008619 L21,13.3523848 L17.6001291,11.989972 C17.5677781,11.9965478 17.5342922,12 17.5,12 L9.5,12 C9.22385763,12 9,11.7761424 9,11.5 L9,10.5 C9,10.2238576 9.22385763,10 9.5,10 L15.174,10 L13.173966,8.00045576 Z"
        fill={checkColor(color)}
        fillRule="evenodd"
      />
    </svg>
  );
}
